import { useApiQuery } from '../useApiQuery';
import { reminderKeys } from '@/lib/queryKeys';
import { remindersV2 } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { ReminderWithSteps } from '@/types/reminder';

interface DetailResponse {
  data: ReminderWithSteps;
}

/**
 * Fetch a single reminder with its steps (spec §13.5 detail drawer).
 */
export function useReminderDetail(
  id: string | undefined | null,
  refetchInterval: number | false = false,
) {
  return useApiQuery<ReminderWithSteps>({
    queryKey: reminderKeys.detail(id ?? '__none__'),
    queryFn: async () => {
      const res = await apiGet<DetailResponse>(operationsClient, remindersV2.detail(id!));
      return res.data;
    },
    enabled: Boolean(id),
    refetchInterval,
    showErrorToast: false,
  });
}
